import styled from 'styled-components';

interface IQuestionProps {
  isDesk: boolean;
}

const QuestionText = styled.div<IQuestionProps>`
  > p {
    font-size: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
    font-weight: 700;
    word-break: break-word;
  }
`;

const SvgQuestionBox = styled.div<IQuestionProps>`
  display: flex;
  justify-content: end;
  padding-right: ${({ isDesk }) => (isDesk ? '10px' : '7px')};
  padding-top: 3px;

  > svg {
    width: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
    height: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
  }
`;

const Wrapper = styled.div<IQuestionProps>`
  display: grid;
  grid-template-columns: ${({ isDesk }) => (isDesk ? '48px auto' : '1fr 7fr')};
  padding: 0 8px 16px;
`;

const QuestionWrapper = styled.div`
  background: #fafafa;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 16px 0 0 0;
  margin-bottom: 16px;
  border-bottom: 2px solid #f5f5f5;

  &.last {
    border: none;
  }
`;

const Owner = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #6f6f6f;
  padding-top: 6px;
`;

export { Owner, QuestionText, QuestionWrapper, SvgQuestionBox, Wrapper };
